import { MdArrowDownward, MdArrowUpward } from 'react-icons/md';
import { Button, Loader } from 'rsuite';
import { Skeleton } from '../../../../../../../components';
import { useCampaign } from '../../hooks/useCampaign';
import { CampaignTypeUpsertModal } from '../modals/CampaignTypeUpsertModal';
import { CampaignTypeDeleteModal } from '../modals/DeleteCampaign';
import styles from './SetupCampaignType.module.scss';

export const SetupCampaignType = () => {
  const { campaignFields, state, handlers } = useCampaign();
  const { openUpsert, selectedItem, openDelete, isLoadingCampaignTypes, isOrderLoading } = state;
  const {
    setOpenUpsert,
    setOpenDelete,
    handleOpenDelete,
    handleOpenCreate,
    handleOpenEdit,
    handleSaveCampaignType,
    moveUp,
    moveDown,
    mutateCampaignTypeDelete,
    existsCampaignWithSameName,
  } = handlers;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <h2 className={styles.title}>Tipos de campanhas</h2>
          <p className={styles.description}>
            Crie diferentes tipos de campanhas promocionais e defina a priorização entre eles. Se duas campanhas de tipos diferentes estiverem vigentes ao mesmo
            tempo será enviado para o ERP o preço de campanha de tipo prioritário.
          </p>
        </div>
        <button type="button" onClick={handleOpenCreate} className={styles.addButton}>
          Adicionar novo
        </button>
      </div>

      <div className={styles.table}>
        <div className={styles.tableHeader}>
          <div>Prioridade</div>
          <div>Tipo de campanha</div>
          <div></div>
        </div>

        {isLoadingCampaignTypes && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index}>
                <Skeleton height={40} />
              </div>
            ))}
          </div>
        )}

        {!isLoadingCampaignTypes && isOrderLoading && (
          <div className={styles.loader}>
            <Loader />
          </div>
        )}

        {!isLoadingCampaignTypes &&
          campaignFields.fields.map((type, index) => (
            <div key={type.id} className={styles.tableRow}>
              <div className={styles.priority}>#{type.order}</div>
              <div className={styles.campaignType}>{type.campaignType}</div>
              <div className={styles.actions}>
                <button
                  type="button"
                  onClick={() => moveUp(index)}
                  disabled={index === 0 || state.isOrderLoading}
                  className={styles.iconButton}
                  title="Mover para cima"
                >
                  <MdArrowUpward size={20} />
                </button>
                <button
                  type="button"
                  onClick={() => moveDown(index)}
                  disabled={index === campaignFields.fields.length - 1 || state.isOrderLoading}
                  className={styles.iconButton}
                  title="Mover para baixo"
                >
                  <MdArrowDownward size={20} />
                </button>
                <Button appearance="link" type="button" onClick={() => handleOpenEdit({ ...type, index })}>
                  Editar
                </Button>
                <Button appearance="link" type="button" onClick={() => handleOpenDelete({ ...type, index })} disabled={campaignFields.fields.length === 1}>
                  Excluir
                </Button>
              </div>
            </div>
          ))}
      </div>

      <CampaignTypeUpsertModal
        open={openUpsert}
        onClose={() => setOpenUpsert(false)}
        initialValue={selectedItem}
        onSave={handleSaveCampaignType}
        handleValidateName={existsCampaignWithSameName}
      />
      <CampaignTypeDeleteModal
        open={openDelete}
        onCancel={() => setOpenDelete(false)}
        onConfirm={() => mutateCampaignTypeDelete(selectedItem?.typeId ?? '')}
        campaignsName={selectedItem?.campaignsName ?? []}
      />
    </div>
  );
};
